/**
 * Attempts to determine the embedding/parent origin.
 * - If in an iframe, use document.referrer's origin (path-safe).
 * - Fallback to window.location.origin.
 * - Always returns a string (best effort) or null if nothing is available.
 */
export function getParentOrigin(): string | null {
    try {
        const isFramed = window.self !== window.top;
        console.log("is framed", isFramed);
        console.log("document referrer", document.referrer);
        if (isFramed && document.referrer) {
            const refUrl = new URL(document.referrer);
            // Return the full referrer URL (not just origin) so our "contains" matching can work,
            // but also log both in App.tsx for clarity.
            console.log("refUrl", refUrl);
            return refUrl.href;
        }
    } catch (err) {
        // cross-origin access can throw; ignore and continue
        console.log("get parent origin error", err);
    }

    try {
        console.log("window location href", window.location.href);
        return window.location.href || window.location.origin || null;
    } catch {
        return null;
    }
}
